/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2024, Zumper
 */

import type { TopListable } from '@zcode/bizos'
import { IS_ZUMPER_RENTALS, ZUMPER_RENTALS_REDIRECTS } from '@zcode/nr-utils'
import { APP_HOSTNAME } from '@zcode/nr-utils'
import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import { routesConstants } from '@zcode/zumper-routes'

const { ZUMPER_RENTALS_NO_REDIRECT_PATH_PATTERN } = routesConstants

const ORIGIN = typeof window !== 'undefined' ? window.location.origin : `https://${APP_HOSTNAME}`
export const ZUMPER_ORIGIN = ORIGIN.replace('zumperrentals.com', 'zumper.com')

export const getRedirectDestination = (
  entity: Listable | Property | Pin<RawPinInventorySearch> | TopListable
) => {
  const { isBuilding } = entity
  const redirectToZumper = ZUMPER_RENTALS_REDIRECTS && IS_ZUMPER_RENTALS && isBuilding

  const redirectToZumperRentals = false
  return { redirectToZumper, redirectToZumperRentals }
}

export const getShouldRedirectToZumper = (
  urlOrEntity: Listable | Property | Pin<RawPinInventorySearch> | TopListable | string,
  isZumperRentals: boolean = IS_ZUMPER_RENTALS
) => {
  let shouldRedirectToZumper = false

  if (isZumperRentals) {
    if (typeof urlOrEntity === 'string') {
      const isSameOrigin =
        new URL(urlOrEntity, ORIGIN).origin.toLowerCase() === ORIGIN.toLowerCase()
      if (isSameOrigin) {
        const isZRNoRedirectPath = ZUMPER_RENTALS_NO_REDIRECT_PATH_PATTERN.test(urlOrEntity)
        shouldRedirectToZumper = isSameOrigin && !isZRNoRedirectPath
      } else {
        shouldRedirectToZumper = urlOrEntity === routesConstants.ADVERTISE_URL
      }
    } else {
      shouldRedirectToZumper = getRedirectDestination(urlOrEntity).redirectToZumper
    }
  }
  return {
    shouldRedirectToZumper,
    transformedOrigin: ZUMPER_ORIGIN,
  }
}
